import { getTransferPricingRelationships } from '@/http'

export default {
  data() {
    return { relationships: [], relationshipsLoading: false, relationshipsFailed: false, relationshipsRequest: 0 }
  },
  created() { this.fetchRelationships() },
  beforeDestroy() { this.relationshipsRequest++ },
  methods: {
    async fetchRelationships() {
      const request = ++this.relationshipsRequest
      this.relationshipsLoading = true
      this.relationshipsFailed = false
      try {
        const { data } = await getTransferPricingRelationships()
        if (request === this.relationshipsRequest) this.relationships = data
      } catch (error) {
        if (request === this.relationshipsRequest) this.relationshipsFailed = true
      } finally {
        if (request === this.relationshipsRequest) this.relationshipsLoading = false
      }
    },
  },
}
